var map = {
	"./Benchmark.jpg": 3772,
	"./Digital globe.jpg": 2798,
	"./Final1.jpg": 5056,
	"./Multimodal.jpg": 2935,
	"./RightPartner3.jpg": 3814,
	"./bidirectional.jpg": 84,
	"./logo-lorri.png": 1595,
	"./logo.png": 2996,
	"./logo3.png": 869,
	"./mid_image.jpg": 5325,
	"./myTransporter-banner.jpg": 2250,
	"./plus-icon.svg": 5083,
	"./search-glass.jpg": 8022,
	"./shell.jpg": 951,
	"./transporter.jpg": 255,
	"./transporter_logo.png": 9513,
	"./upper_part.jpg": 2641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1126;